import React from "react";
import { MinusIcon, PlusIcon } from "@heroicons/react/solid";
import { ReserveFormAdminReservation } from "@/components/reserve/Reserve/views/ReserveFormAdminReservation";
import { useReserveForm } from "@/components/reserve/Reserve/ReserveFormProvider";

export const ReserveFormOtherUserReservation: React.FC = () => {
  const {
    allowOthers,
    setEnableAdminReservation,
    enableAdminReservation,
    owner
  } = useReserveForm();
  if (!allowOthers) return null;

  return (
    <div className="text-left">
      <div>
        <button
          onClick={(ev) => {
            ev.preventDefault();
            setEnableAdminReservation((x) => !x);
          }}
          className="flex items-center [.tactic-v2_&]:gap-1 pb-2 [.tactic-v2_&]:font-inter font-normal text-secondary [.tactic-v2_&]:text-sm [.tactic-v2_&]:leading-none [.tactic-v2_&]:tracking-normal [.tactic-v2_&]:pb-0 [.tactic-v2_&]:text-secondary-foreground"
        >
          {!enableAdminReservation ? (
            <PlusIcon className="mr-1.5 h-6 w-4" />
          ) : (
            <MinusIcon className="mr-1.5 h-6 w-4" />
          )}
          Create Reservation for Another User
        </button>
        <ReserveFormAdminReservation />
      </div>
    </div>
  );
};
